import { Icon } from '@livable/saas-react-components';
import React from 'react';
import useStyles from './billDetailsStyles';

/** Address row that opens a line items or allocation table. */
export function AccordionHeader(_ref) {
  let isExpanded = _ref.isExpanded,
    onToggle = _ref.onToggle,
    title = _ref.title;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("button", {
    "aria-expanded": isExpanded,
    className: "".concat(classes.accordionHeader, " ").concat(isExpanded ? classes.accordionArrowOpen : ''),
    onClick: onToggle,
    type: "button"
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.accordionHeaderTitle
  }, title), /*#__PURE__*/React.createElement(Icon, {
    state: "grey",
    type: "arrow-line-down"
  }));
}